import {
	isBlank
}
from 'voUtils/tools.js';

export default {
	data() {
			return {
				name: undefined,
			};
		},
		mounted() {
			// Warte darauf, dass die DOM-Elemente sicher existieren
			this.$nextTick(() => {
				const modal = document.getElementById("index-modal");
				const closeBtn = document.querySelector(".index-close");
				const now = new Date();
				const start = new Date(2026, 10, 3, 0, 1, 0); // 03.11.2026, 00:01
				const end = new Date(2026, 10, 7, 23, 59, 59); // 07.11.2026, 23:59
				const imZeitraum = now >= start && now <= end;

				if (!modal || !closeBtn) {
					console.error("Modal oder Close-Button nicht gefunden!");
					return;
				}

				//console.log('Modal-Skript geladen');

				// Funktion zum Setzen eines Cookies
				function setCookie(name, value, days) {
					let date = new Date();
					date.setTime(date.getTime() + days * 12 * 60 * 60 * 1000);
					document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
				}

				// Funktion zum Abrufen eines Cookies
				function getCookie(name) {
					let cookies = document.cookie.split("; ");
					for (let cookie of cookies) {
						let [key, value] = cookie.split("=");
						if (key === name) {
							return value;
						}
					}
					return null;
				}

				// Prüfen, ob das Modal bereits angezeigt wurde (Cookie existiert)
				if (imZeitraum && !getCookie("modalShownReiche")) {
					modal.style.display = "flex"; // Modal anzeigen
					setCookie("modalShownReiche", "true", 1); // Cookie setzen (1 Tag Gültigkeit)
				}

				// Schließen-Event (X-Button)
				closeBtn.addEventListener("click", function () {
					modal.style.display = "none";
				});

				// Schließen bei Klick außerhalb des Modals
				window.addEventListener("click", function (event) {
					if (event.target === modal) {
						modal.style.display = "none";
					}
				});
			});
		},
};